var _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewTabIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eTIjBLPYlrp1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 2.984852,
    height: 22.156784,
    rx: 0,
    ry: 0,
    transform: "matrix(.999995 0 0 1 0.921608 0.827249)",
    fill: "#000207",
    strokeWidth: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2.984852,
    height: 22.156784,
    rx: 0,
    ry: 0,
    transform: "matrix(.707103 0.707103-.707107 0.707107 20.783101 0.827249)",
    fill: "#000207",
    strokeWidth: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.984852,
    height: 22.156784,
    rx: 0,
    ry: 0,
    transform: "matrix(0 1-1 0 23.078392 19.999181)",
    fill: "#000207",
    strokeWidth: 0
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2.984852,
    height: 22.156784,
    rx: 0,
    ry: 0,
    transform: "matrix(1 0 0 0.266049 20.09354 14.104391)",
    fill: "#000207",
    strokeWidth: 0,
    strokeLinecap: "square"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2.984852,
    height: 22.156784,
    rx: 0,
    ry: 0,
    transform: "matrix(1 0 0 0.395775 20.09354 0.827249)",
    fill: "#000207",
    strokeWidth: 0,
    strokeLinecap: "square"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 2.984852,
    height: 22.156784,
    rx: 0,
    ry: 0,
    transform: "matrix(0 1-.395775 0 22.773896 0.827249)",
    fill: "#000207",
    strokeWidth: 0,
    strokeLinecap: "square"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 2.984852,
    height: 22.156784,
    rx: 0,
    ry: 0,
    transform: "matrix(0 1-.266049 0 9.78479 0.827249)",
    fill: "#000207",
    strokeWidth: 0,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTabIcon);
export default __webpack_public_path__ + "static/media/new-tab-icon.150584f1177ea96c1624d5ce38a64f27.svg";
export { ForwardRef as ReactComponent };